import { encodeAccountModulesInstallation } from './installAccountModules';
import { encodeDataForLinkingSmartAccount } from '../utils/encodeDataForLinkingSmartAccount';
/**
 * Batch operation to install AccountModules and an app in a single transaction.
 * If the wallet is not linked, this also includes wallet linking to ensure auth checks pass.
 */
export async function installAccountModulesAndApp(args) {
    const { smartAccount, signer, accountModulesAddress, appRegistryDapp, spaceDapp, appAddress, price, initData = '0x', } = args;
    const rootKeyAddress = (await signer.getAddress());
    const abstractAccountAddress = smartAccount.address;
    const isLinked = await spaceDapp.walletLink.checkIfLinked(rootKeyAddress, abstractAccountAddress);
    const encodedAccountModulesInstallation = await encodeAccountModulesInstallation({
        smartAccount,
        accountModulesAddress,
    });
    const encodedAppInstallation = appRegistryDapp.installer.interface.encodeFunctionData('installApp', [appAddress, smartAccount.address, initData]);
    if (isLinked) {
        return smartAccount.sendUserOp({
            toAddress: [smartAccount.address, appRegistryDapp.installer.address],
            callData: [encodedAccountModulesInstallation, encodedAppInstallation],
            value: [0n, price],
            functionHashForPaymasterProxy: 'installAccountModulesAndApp',
            spaceId: undefined,
            signer,
        });
    }
    const encodedWalletLink = await encodeDataForLinkingSmartAccount(spaceDapp, signer, abstractAccountAddress);
    return smartAccount.sendUserOp({
        toAddress: [
            spaceDapp.walletLink.address,
            smartAccount.address,
            appRegistryDapp.installer.address,
        ],
        callData: [encodedWalletLink, encodedAccountModulesInstallation, encodedAppInstallation],
        value: [0n, 0n, price],
        functionHashForPaymasterProxy: 'installAccountModulesAndApp',
        spaceId: undefined,
        signer,
    });
}
